import { useEffect, useState } from 'react';
import styled from 'styled-components';
import Hero from '../components/Hero';
import SectionTitle from '../components/SectionTitle';
import OpeningHours from '../components/OpeningHours';
import Gallery from '../components/Gallery';
import { getSettings, getOpeningHours } from '../services/settingsService';

const Section = styled.section`
  max-width: 1200px;
  margin: 0 auto;
  padding: 3rem 1.5rem;
`;

const Text = styled.p`
  max-width: 800px;
  margin-bottom: 2rem;
  line-height: 1.7;
`;

function Home() {
  const [settings, setSettings] = useState(null);
  const [openingHours, setOpeningHours] = useState([]);

  useEffect(() => {
    const loadData = async () => {
      setSettings(await getSettings());
      setOpeningHours(await getOpeningHours());
    };

    loadData();
  }, []);

  if (!settings) return null;

  return (
    <>
      <Hero title={settings.heroTitle} text={settings.heroText} />

      <Section>
        <SectionTitle>Über uns</SectionTitle>
        <Text>
          Willkommen im Stadtheuriger zum Brückl. Bei uns genießen Sie regionale Spezialitäten,
          gute Getränke und eine gemütliche Atmosphäre für Familie, Freunde und schöne Abende.
        </Text>
      </Section>

      <Gallery />

      <Section>
        <SectionTitle>Öffnungszeiten</SectionTitle>
        <OpeningHours items={openingHours} />
      </Section>
    </>
  );
}

export default Home;